import React, { Component } from 'react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Auth0Provider } from '@auth0/auth0-react';
import { UserContextProvider } from './UserContextProvider';
import PublicShareLayout from './pages/PublicShareLayout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const domain = process.env.REACT_APP_AUTH_DOMAIN;
const clientId = process.env.REACT_APP_CLIENT_ID;
const audience = process.env.REACT_APP_AUDIENCE;

const onRedirectCallback = (appState) => {
    const target = appState?.returnTo || window.location.pathname;
    window.history.replaceState({}, document.title, target);
};

class AppWithAuth extends Component {
    render() {
        // /share/* paths are unauthenticated brand-funnel pages: skip Auth0 +
        // UserContextProvider so the global axios interceptor never installs and
        // no Auth0 silent-auth iframe fires for cold visitors.
        if (typeof window !== 'undefined' && window.location.pathname.startsWith('/share/')) {
            return <PublicShareLayout />;
        }

        return (
            <Auth0Provider
                domain={domain}
                clientId={clientId}
                useRefreshTokens={true}
                cacheLocation={'localstorage'}
                onRedirectCallback={onRedirectCallback}
                authorizationParams={{
                    redirect_uri: window.location.origin,
                    scope: 'openid profile email phone offline_access all',
                    audience: audience
                }}
            >
                <UserContextProvider>
                    <BrowserRouter>
                        <Elements stripe={stripePromise}>
                            <App />
                        </Elements>
                    </BrowserRouter>
                </UserContextProvider>
            </Auth0Provider>
        );
    }
}

export default AppWithAuth;
